const TOKEN_ALIAS = '__auth__';
// Read the token per request: auth.js refreshes it in localStorage while the app is open.
const getToken = (): string | null => localStorage.getItem(TOKEN_ALIAS);

export const getAliasHeader = (): Record<string, string> => ({
	'Authorization': `Bearer ${getToken()}`,
	'Content-Type': 'application/json',
	'Accept': '*/*',
	'Accept-Encoding': 'gzip, deflate, br',
});
export const getAliasHeaderFormData = (): Record<string, string> => ({
	'Authorization': `Bearer ${getToken()}`,
});

export const getAliasHeaderTwo = (): Record<string, string> => ({
	'Authorization': `Bearer ${getToken()}`,
	'Content-Type': 'application/json',
});

export const LIMIT_PAYLOAD = 50;

export const BMO_API_V2_FORM_DATA = 'https://ks.staging.unifon.no/api/v2/telenor/';

export const isProduction = process.env['NODE_ENV'] === 'production';
